import { type ReactNode, useMemo } from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { type Branding, buildTheme } from "./create-theme";

interface Props {
  branding?: Branding;
  children: ReactNode;
}

/**
 * Provides the MUI theme (both colour schemes), the date-picker localization
 * adapter, and the CSS baseline. Light/dark selection is handled by MUI's
 * `useColorScheme` (system default, user-toggleable, self-persisting).
 */
export function ThemeModeProvider({ branding, children }: Props) {
  const theme = useMemo(() => buildTheme(branding), [branding]);
  return (
    <ThemeProvider theme={theme} defaultMode="system" disableTransitionOnChange>
      <CssBaseline enableColorScheme />
      <LocalizationProvider dateAdapter={AdapterDayjs}>{children}</LocalizationProvider>
    </ThemeProvider>
  );
}
